export default class GamePredictionsStats {
  public participations: number = 0;
  public points: number = 0;
}
